// import React, { useContext, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { ConfigContext } from "../../Context/ConfigContext";
// import axios from "axios";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { axiosGet } from "../../Apis/axiosMethods";

// const OsscaBanner = () => {
//     const navigate = useNavigate();

//     const [banner, setBanner] = useState([]);
//     const [activeIndex, setActiveIndex] = useState(0);

//     useEffect(() => {
//         const getBanners = async () => {
//             try {
//                 const response = await axiosGet(`/Dashboard/GetHomeDashboardBanners`, { status: 1 });

//                 if (response?.data?.success) {
//                     setBanner(
//                         Array.isArray(response?.data?.data)
//                             ? response?.data?.data
//                             : []
//                     );
//                 }
//             } catch (error) {
//                 if (error?.name !== "CanceledError") {
//                     console.log("Banner Error :", error);
//                 }
//             }
//         };

//         getBanners();
//     }, []);

//     const getFileExtension = (url) => {
//         if (!url) return "";

//         return url
//             .split("?")[0]
//             .split(".")
//             .pop()
//             .toLowerCase();
//     };

//     const handleBannerClick = (link) => {
//         if (!link) return;

//         window.scrollTo(0, 0);

//         if (link.startsWith("/")) {
//             navigate(link);
//         } else {
//             window.open(link, "_self");
//         }
//     };

//     if (!banner.length) return null;

//     const settings = {
//         dots: true,
//         infinite: banner.length > 1,
//         autoplay: banner.length > 1,
//         autoplaySpeed: 14000,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: false,
//         speed: 500,
//         afterChange: (index) => {
//             setActiveIndex(index % banner.length);
//         }
//     };

//     return (
//         <div className="container">
//             <div className="row">
//                 <div
//                     className="col-md-12"
//                     style={{ height: "250px" }}
//                 >
//                     <Slider {...settings}>
//                         {banner.map((item, index) => {
//                             const ext = getFileExtension(item.business_home_banner_path_url);
//                             const isActive = index === activeIndex;

//                             return (
//                                 <div
//                                     key={item.business_home_banner_id}
//                                 >
//                                     {["mp4", "webm", "ogg"].includes(ext) && (
//                                         <video
//                                             src={isActive ? item.business_home_banner_path_url : undefined}
//                                             autoPlay={isActive}
//                                             muted
//                                             loop
//                                             playsInline
//                                             preload={isActive ? "auto" : "none"}
//                                             style={{
//                                                 width: "100%",
//                                                 height: "250px",
//                                                 objectFit: "contain",
//                                                 cursor: "pointer"
//                                             }}
//                                             onClick={() => handleBannerClick(item.business_home_banner_link)}
//                                         />
//                                     )}

//                                     {["jpg", "jpeg", "png", "gif"].includes(ext) && (
//                                         <img
//                                             src={item.business_home_banner_path_url}
//                                             alt="Banner"
//                                             loading={
//                                                 isActive
//                                                     ? "eager"
//                                                     : "lazy"
//                                             }
//                                             decoding="async"
//                                             style={{
//                                                 width: "100%",
//                                                 height: "250px",
//                                                 objectFit: "contain",
//                                                 cursor: "pointer"
//                                             }}
//                                             onClick={() =>
//                                                 handleBannerClick(
//                                                     item.business_home_banner_link
//                                                 )
//                                             }
//                                         />
//                                     )}
//                                 </div>
//                             );
//                         })}
//                     </Slider>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default OsscaBanner;



import {
    useEffect,
    useState,
    useMemo,
    useCallback,
    useRef
} from "react";

import { useNavigate } from "react-router-dom";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { axiosGet } from "../../Apis/axiosMethods";

const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp"];
const VIDEO_EXTENSIONS = ["mp4", "webm", "ogg"];

const OsscaBanner = () => {
    const navigate = useNavigate();

    const sliderRef = useRef(null);
    const videoRefs = useRef({});

    const [banner, setBanner] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);

    // Fetch banners
    const getBanners = useCallback(async (signal) => {
        try {
            const response = await axiosGet(
                "/Dashboard/GetHomeDashboardBanners",
                { status: 1 },
                { signal }
            );

            if (response?.data?.success) {
                setBanner(
                    Array.isArray(response?.data?.data)
                        ? response.data.data
                        : []
                );
            }
        } catch (error) {
            if (
                error?.name !== "CanceledError" &&
                error?.name !== "AbortError"
            ) {
                console.error("Banner Error:", error);
            }
        }
    }, []);

    useEffect(() => {
        const controller = new AbortController();

        getBanners(controller.signal);

        return () => {
            controller.abort();
        };
    }, [getBanners]);

    // Get file extension
    const getFileExtension = (url) => {
        if (!url) return "";

        return url
            .split("?")[0]
            .split(".")
            .pop()
            .toLowerCase();
    };

    // Handle banner click
    const handleBannerClick = (link) => {
        if (!link) return;

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });

        if (link.startsWith("/")) {
            navigate(link);
        } else {
            window.open(link, "_self");
        }
    };

    // Pause all inactive videos
    const pauseInactiveVideos = useCallback((currentIndex) => {
        Object.entries(videoRefs.current).forEach(
            ([index, video]) => {
                if (!video) return;

                if (Number(index) !== currentIndex) {
                    video.pause();
                    video.currentTime = 0;
                }
            }
        );
    }, []);

    // Slider settings
    const settings = useMemo(
        () => ({
            dots: true,
            infinite: banner.length > 1,
            autoplay: banner.length > 1,
            autoplaySpeed: 14000,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            speed: 500,
            waitForAnimate: true,

            beforeChange: (oldIndex, newIndex) => {
                pauseInactiveVideos(newIndex);
            },

            afterChange: (index) => {
                setActiveIndex(index);
                pauseInactiveVideos(index);
            }
        }),
        [banner.length, pauseInactiveVideos]
    );

    // Reset active index when banners change
    useEffect(() => {
        setActiveIndex(0);

        if (sliderRef.current) {
            sliderRef.current.slickGoTo(0, true);
        }
    }, [banner.length]);

    // Play active video and pause inactive videos
    useEffect(() => {
        const activeVideo = videoRefs.current[activeIndex];

        Object.entries(videoRefs.current).forEach(
            ([index, video]) => {
                if (!video) return;

                if (Number(index) !== activeIndex) {
                    video.pause();
                }
            }
        );

        if (activeVideo) {
            activeVideo.play().catch(() => {
                // Autoplay can be blocked by the browser.
            });
        }
    }, [activeIndex, banner]);

    if (!banner.length) return null;

    return (
        <div className="container">
            <div className="row">
                <div
                    className="col-md-12"
                    style={{ height: "250px" }}
                >
                    <Slider
                        ref={sliderRef}
                        {...settings}
                    >
                        {banner.map((item, index) => {
                            const url =
                                item.business_home_banner_path_url;

                            const ext = getFileExtension(url);

                            const isActive = index === activeIndex;

                            const isImage =
                                IMAGE_EXTENSIONS.includes(ext);

                            const isVideo =
                                VIDEO_EXTENSIONS.includes(ext);

                            return (
                                <div
                                    key={item.business_home_banner_id}
                                >
                                    {isImage && (
                                        <img
                                            src={url}
                                            alt={`Ghayar banner ${index + 1}`}
                                            loading={
                                                isActive ? "eager" : "lazy"
                                            }
                                            fetchPriority={
                                                isActive ? "high" : "auto"
                                            }
                                            decoding="async"
                                            width="1200"
                                            height="250"
                                            style={{
                                                width: "100%",
                                                height: "250px",
                                                objectFit: "contain",
                                                cursor: "pointer"
                                            }}
                                            onClick={() =>
                                                handleBannerClick(
                                                    item.business_home_banner_link
                                                )
                                            }
                                        />
                                    )}

                                    {isVideo && (
                                        <video
                                            ref={(element) => {
                                                if (element) {
                                                    videoRefs.current[index] =
                                                        element;
                                                } else {
                                                    delete videoRefs.current[index];
                                                }
                                            }}
                                            src={
                                                isActive ? url : undefined
                                            }
                                            autoPlay={isActive}
                                            muted
                                            loop
                                            playsInline
                                            preload="none"
                                            width="1200"
                                            height="250"
                                            style={{
                                                width: "100%",
                                                height: "250px",
                                                objectFit: "contain",
                                                cursor: "pointer"
                                            }}
                                            onClick={() =>
                                                handleBannerClick(
                                                    item.business_home_banner_link
                                                )
                                            }
                                        />
                                    )}
                                </div>
                            );
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    );
};

export default OsscaBanner;